import { RouteRecordRaw } from 'vue-router';
import Home from './home.vue';
// import { preloadData } from '@/utils/preload-page-data';
export const ROUTER_NAME_HOME = 'home';

export const homeRouter: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: ROUTER_NAME_HOME,
    component: Home,
    // beforeEnter: () => {
    //   preloadData();
    // },
  },
];
